import { combineReducers } from 'redux';
import { coreOnboardingProgressGetAsyncSlice } from './get';
import { coreOnboardingProgressUpdateSyncSlice } from './update';
import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';

export const onboardingProgressReducers = combineReducers({
	get: joinReducers([
		coreOnboardingProgressGetAsyncSlice.asyncReducers,
		coreOnboardingProgressUpdateSyncSlice.syncReducer
	], coreOnboardingProgressGetAsyncSlice.asyncState)
});

export const onboardingProgressWatchers = combineAllWatchers([
	coreOnboardingProgressGetAsyncSlice.asyncWatchers
]);
